export const ADDED_TO_SITE = [
    {label: 'Anytime', id: 'any', labelGR: 'Οποιαδήποτε στιγμή'},
    {label: 'Last 24 hours', id: '24h', labelGR: 'Τελευταίες 24 ώρες'},
    {label: 'Last 3 days', id: '3d', labelGR: 'Τελευταίες 3 ημέρες'},
    {label: 'Last 7 days', id: '7d', labelGR: 'Τελευταίες 7 ημέρες'},
    {label: 'Last 14 days', id: '14d', labelGR: 'Τελευταίες 14 ημέρες'},
    {label: 'Last 30 days', id: '30d', labelGR: 'Τελευταίες 30 ημέρες'}
];

export const HEATING_COOLING = [
    {label: 'Air condition', id: 'ac', labelGR: 'Κλιματιστικό'},
    {label: 'Heating', id: 'heat', labelGR: 'Θέρμανση'},
    {label: 'Underfloor heating', id: 'underfloor', labelGR: 'Υποδαπέδια θέρμανση'}
];

export const PROPERTY_CONDITION = [
    {label: 'New built', id: 'new', labelGR: 'Νεόδμητο'},
    {label: 'Existing built', id: 'old', labelGR: 'Υφιστάμενο κτίσμα'},
    {label: 'Under construction', id: 'under', labelGR: 'Υπό κατασκευή'}
];

export const EXTRAS = [
    {label: 'Garden', id: 'garden', labelGR: 'Κήπος'},
    {label: 'Pool', id: 'pool', labelGR: 'Πισίνα'},
    {label: 'Balcony', id: 'balcony', labelGR: 'Μπαλκόνι'},
    {label: 'Parking', id: 'parking', labelGR: 'Στάθμευση'},
    {label: 'Fireplace', id: 'fireplace', labelGR: 'Τζάκι'}
];

export const SORTING = [
    { label: 'Most recent', value: 'recent', labelGR: 'Πιο πρόσφατο' },
    { label: 'Highest price', value: 'pricehigh', labelGR: 'Υψηλότερη τιμή' },
    { label: 'Lowest price', value: 'pricelow', labelGR: 'Χαμηλότερη τιμή' },
    { label: 'Largest area', value: 'areahigh', labelGR: 'Μεγαλύτερη έκταση' }
]